<template>
  <b-modal
    id="add-team"
    :title="$translate('new_team')"
    hide-footer
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div v-if="isLoaded" class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="name" form-group-id="name" placeholder="name" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="description" form-group-id="description" placeholder="description" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Multiselect
          :options="userOptions"
          form-group-id="users"
          placeholder="users"
          placeholder-input="Select Users"
          :on-change="v => (users = v)"
        />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-100" @click="close">
          {{ 'Close' | i18n }}
        </b-button>
        <b-button
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-100"
          :disabled="!name || !users.length"
          @click="onSubmit"
        >
          {{ 'new_team' | i18n }}
        </b-button>
      </div>
    </div>
    <Loader v-else />
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import Multiselect from '../../common/multiselect';
import Loader from '../../common/loader';
import { ReportsMixin, NotificationMixin } from '../../../../mixins';

export default {
  title: 'Add team',
  components: { Input, Loader, Multiselect },
  mixins: [ReportsMixin, NotificationMixin],
  props: {
    getPage: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      name: '',
      description: '',
      users: [],
      userOptions: [],
      isLoaded: false,
      preventCloseLocal: true
    };
  },
  methods: {
    async show() {
      this.clear();
      this.isLoaded = false;
      const response = await this.reportsService.getUsersLookup();
      this.userOptions = response.data.map(item => ({ value: item.id, text: `${item.email} (${item.username})` }));
      this.isLoaded = true;
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'add-team');
      this.clear();
    },
    clear() {
      this.name = '';
      this.description = '';
      this.users = [];
    },
    hide(e) {
      if (this.preventCloseLocal) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        const payload = {
          name: this.name,
          description: this.description,
          userIds: this.users.map(i => i.value)
        };
        await this.reportsService.createTeam(payload);
        this.$root.$emit('bv::hide::modal', 'add-team');
        await this.getPage();
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: this.$translate(err.message) });
        this.preventCloseLocal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-team .modal-dialog {
  max-width: 700px !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

.px-100 {
  padding-left: 100px;
  padding-right: 100px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
